angular.module('cvsApp').service('quickRegistrationService',['networkService', 'xdrService', 'quickRegistrationModel', 'configManager', function (NS, XS, QRM, CM) {
   	
	function quickRegistrationService (){	
		this.quickRegistration = function(req, callBackSuccess){
			//get url 
			var url = CM.getGuestUrl('QUICK_REGISTRATION',"2.0");
			var request = {url:url,
							header:{'Accept':'application/xml,application/json,text/plain,*/*', 'Content-Type': 'application/xml'},
							data:getRequestBody(req),
							onSuccess:callBackSuccess
						};
			cvsUtility.commonServiceCode(url,"quickRegisterSpecialtyUser",QRM,request,callBackSuccess,NS);
							
		};
		
		var getRequestBody = function(req){
				var timeStamp=cvsUtility.getTimeStamp();
					
				var requestJson = {request:{
								tokenID:req.tokenId,
								tokenType:'Guest',
								apiKey:cvsUtility.queryMap.apikey,
								timestamp:timeStamp,
								emailAddress: req.email,
								password:req.password,
								challengeAnswer:{answer1:{questionId:req.questionId1,answerText:req.answerText1},answer2:{questionId:req.questionId2,answerText:req.answerText2}},
								userAcceptedAgreement:req.userAcceptedAgreement,
								LinkSource:req.LinkSource,
								componentID:req.componentID,
								fastIndicator:req.fastIndicator
							}};
			if(req.accessKey){
				requestJson.request.accessKey=req.accessKey;
			}
			if(req.contextInformation){
				requestJson.request.contextInformation=req.contextInformation;

			}
				
				return cvsUtility.JSONToXml(requestJson);

			};			
	}
	
	return new quickRegistrationService();	
}]);
